import templates from "./index";

export const getTemplate = templateName => templates[templateName];
